<!-- checkbox-filter.component.html -->
<div class="custom-filter-wrapper">
    <!-- Header with hamburger -->
    <div class="filter-header">
        <span>
            <img class="inbox-search-option" src='assets/qwyn/icons/hamburger_menu.svg' alt="hamburger_icon">
        </span>
    </div>
    <hr class="divider">
    <div class="filter-condition">
        <div class="select-wrapper">
            <!-- TODO :: Revert this when integrated -->
            <select [(ngModel)]="filterValue" (ngModelChange)="onFilterChange()">
                <option [ngValue]="null">Choose one</option>
                <option [ngValue]="true">True</option>
                <option [ngValue]="false">False</option>
            </select>
            <img src="assets/qwyn/icons/filter_dropdown.svg" class="select-icon" alt="dropdown_icon">
        </div>
    </div>
    <ng-container *ngIf="filterValue !== null">
        <hr class="divider">
        <div class="button-wrapper">
            <button class="reset-button" (click)="resetFilter()">
                Reset
            </button>
        </div>
    </ng-container>
</div>
